(function() {
  const rootEl         = document.getElementById('inkdChatbotRoot');
  if (!rootEl) return;

  const launcherBtn    = document.getElementById('inkdChatbotLauncher');
  const panelEl        = document.getElementById('inkdChatbotPanel');
  const closeBtn       = document.getElementById('inkdChatbotClose');
  const formEl         = document.getElementById('inkdChatbotForm');
  const inputEl        = document.getElementById('inkdChatbotInput');
  const messagesEl     = document.getElementById('inkdChatbotMessages');
  const sendBtn        = document.getElementById('inkdChatbotSendBtn');

  let convo = [];
  function niceTime() {
    const d = new Date();
    return d.toLocaleTimeString([], {hour:'numeric', minute:'2-digit'});
  }

  function scrollToBottom() {
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }
  function renderMessage({ role, text, time, isTyping=false }) {
    const row = document.createElement('div');
    row.className = 'inkd-chatbot-msg-row ' + (
      role === 'user'
        ? 'inkd-chatbot-msg-row-user'
        : 'inkd-chatbot-msg-row-bot'
    );

    const bubble = document.createElement('div');
    bubble.className = 'inkd-chatbot-msg-bubble ' + (
      role === 'user'
        ? 'inkd-chatbot-msg-bubble-user'
        : 'inkd-chatbot-msg-bubble-bot'
    );

    const textDiv = document.createElement('div');
    textDiv.className = 'inkd-chatbot-msg-text';

    if (isTyping) {
      textDiv.innerHTML = `
        <span class="inkd-typing">
          <span class="inkd-typing-dot"></span>
          <span class="inkd-typing-dot"></span>
          <span class="inkd-typing-dot"></span>
        </span>
      `;
    } else {
      textDiv.textContent = text;
    }

    const timeDiv = document.createElement('div');
    timeDiv.className = 'inkd-chatbot-msg-time';
    timeDiv.textContent = time || niceTime();

    bubble.appendChild(textDiv);
    bubble.appendChild(timeDiv);
    row.appendChild(bubble);

    messagesEl.appendChild(row);
    scrollToBottom();

    return row;
  }

  function replaceTypingBubble(bubbleRow, finalText) {
    if (!bubbleRow) return;
    const textNode = bubbleRow.querySelector('.inkd-chatbot-msg-text');
    const timeNode = bubbleRow.querySelector('.inkd-chatbot-msg-time');
    if (textNode) {
      textNode.textContent = finalText;
    }
    if (timeNode) {
      timeNode.textContent = niceTime();
    }
  }

  function openPanel() {
    panelEl.classList.add('is-open');
    panelEl.setAttribute('aria-hidden','false');
    setTimeout(() => {
      inputEl && inputEl.focus && inputEl.focus();
    }, 150);
  }
function closePanel() {
  panelEl.classList.remove('is-open');
  panelEl.setAttribute('aria-hidden','true');

  const launcherBtn = document.getElementById('inkdChatbotLauncher');
  if (launcherBtn) {
    launcherBtn.style.display = ''; 
    launcherBtn.classList.remove('inkd-chatbot-launcher--hidden');
  }
}

  launcherBtn.addEventListener('click', function() {
    const opened = panelEl.classList.contains('is-open');
    if (opened) {
      closePanel();
    } else {
      openPanel();
    }
  });
  closeBtn.addEventListener('click', function() {
    closePanel();
  });

  async function handleSend(userText) {
    if (!userText || !userText.trim()) return;
    const clean = userText.trim();
    convo.push({ role: 'user', text: clean });
    renderMessage({ role:'user', text: clean, time: niceTime() });

    inputEl.value = '';
    inputEl.disabled = true;
    sendBtn.disabled = true;

    const typingRow = renderMessage({
      role: 'assistant',
      text: '',
      isTyping: true
    });

    try {
      const payload = {
        customer_id: rootEl.getAttribute('data-customer-id') || 'guest',
        customer_name: rootEl.getAttribute('data-customer-name') || 'Guest',
        shop_name: rootEl.getAttribute('data-shop-name') || '',
        message: clean,
        history: convo  
      };

      const AI_ENDPOINT = 'https://ai-chatbot.inkdstores.workers.dev/'; 
      

      const res = await fetch(AI_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await res.json();

    let replyText;
    if (data.human_handoff) {
    replyText = data.reply || "I'll get a human for you.";
    } else {
    replyText = (data && data.reply)
        ? data.reply
        : "I'm here to help. Can you rephrase that?";
    }
      convo.push({ role: 'assistant', text: replyText });
      replaceTypingBubble(typingRow, replyText);

    } catch (err) {
      console.error('Chatbot error:', err);

      const fallback =
        "Sorry — I'm having trouble reaching the assistant right now.";
      convo.push({ role: 'assistant', text: fallback });

      replaceTypingBubble(typingRow, fallback);
    }
    inputEl.disabled = false;
    sendBtn.disabled = false;
    inputEl.focus();
  }
  formEl.addEventListener('submit', function(e) {
    e.preventDefault();
    handleSend(inputEl.value);
  });
  inputEl.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend(inputEl.value);
    }
  });
})();

